import { LanguageMap } from "./i18n"
import { onlineEng } from "./online"

export const eng: LanguageMap = {
    ...onlineEng,
    "game.localMode": "On one device",
    yacht: "Yacht",
    indigo: "Indigo",
    systemTheme: "System theme",

    "button.startNewGame": "Start new game",
    "button.restartGame": "Restart game",
    "button.cancel": "Cancel",
    "button.startGame": "Start game",
    "button.addPlayer": "Add player",
    "button.removePlayer": "Remove player",
    "button.restart": "Restart",
    "button.rotate": "Rotate",
    "button.light": "Light",
    "button.dark": "Dark",
    "button.system": "System",
    "button.apply": "Apply",
    "button.viewBoard": "View board",
    "button.readRules": "Read rules",
    "button.close": "Close",
    "button.menu": "Menu",

    currentGameWillBeLost: "Current game will be lost.",
    "result.text.h1": "Game is finished!",
    winner: "Winner",
    winners: "Shared victory",
    "game.stageOne": "Add up to four players for a local game on one device.",
    "game.controls": "Turn controls",
    "game.turn": "Turn",
    "game.moving": "Gems are moving",
    "game.collecting": "Players receive gems",
    "game.scoring": "Updating scores",
    "game.tilesLeft": "Tiles in the stack",
    "game.currentTile": "Current tile",
    "game.selectHint": "Select an empty cell, rotate your tile, then press Place tile.",
    "game.finishedHint": "The game is over. Inspect the board or open the results.",
    "game.wait": "Wait for the movement to finish. The turn result has already been saved.",
    "game.gateBlocked": "A path cannot connect two gateway exits. Rotate the tile or choose another cell.",
    "game.invalidState": "The move could not be resolved. The game is unchanged. Try another cell or start a new game.",
    "game.saveFailed": "The browser could not save the game. Keep this page open: reloading may lose progress.",
    "game.rotateLeft": "Left",
    "game.rotateRight": "Right",
    "game.place": "Place tile",
    "game.results": "Results",
    "player.p-1": "Purple",
    "player.p-2": "Turquoise",
    "player.p-3": "Coral",
    "player.p-4": "White",
    "player.name": "Name",
}
